export const updateExplicitBooleanAttribute = ($element, attrName, attrValue) => {
  $element.setAttribute(attrName, attrValue === true ? 'true' : 'false');
};
export const isAttrTrue = attrValue => {
  return attrValue !== null && attrValue !== 'false';
};
export const getBooleanAttribute = ($element, attrName) => {
  return isAttrTrue($element.getAttribute(attrName));
};
export const updateBooleanAttribute = ($element, attrName, attrValue) => {
  const currentAttrValue = $element.getAttribute(attrName);
  if (attrValue === true) {
    if (!isAttrTrue(currentAttrValue)) {
      $element.setAttribute(attrName, '');
    }
  } else if (currentAttrValue !== null) {
    $element.removeAttribute(attrName);
  }
};
export const updateAttribute = ($element, attrName, attrValue) => {
  if (attrValue != null) {
    $element.setAttribute(attrName, String(attrValue));
  } else {
    $element.removeAttribute(attrName);
  }
};
export function getAttribute($element, attrName) {
  let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return $element.getAttribute(attrName) ?? defaultValue;
}
export const isLiteralValue = (literals, value) => {
  return value != null && literals.includes(value);
};
export const updateLiteralAttribute = ($element, literals, attrName, attrValue) => {
  if (isLiteralValue(literals, attrValue)) {
    $element.setAttribute(attrName, attrValue);
  } else {
    $element.removeAttribute(attrName);
  }
};
export function getLiteralAttribute($element, literals, attrName, defaultValue) {
  const attrValue = $element.getAttribute(attrName);
  if (isLiteralValue(literals, attrValue)) {
    return attrValue;
  }
  return defaultValue;
}
export const clampNumber = (value, min, max) => {
  return Math.min(max, Math.max(min, value));
};
const DEFAULT_INTEGER_OPTIONS = {
  itemSizeMultiplier: 1,
  itemSpaceBetween: 0,
  defaultValue: null
};
const applyRange = (value, _ref) => {
  let {
    min,
    max
  } = _ref;
  let result = value;
  if (min != null) {
    result = Math.max(min, result);
  }
  if (max != null) {
    result = Math.min(max, result);
  }
  return result;
};
export const attrValueToInteger = function (value) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_INTEGER_OPTIONS;
  const {
    defaultValue = null,
    itemSizeMultiplier = 1,
    itemSpaceBetween = 0
  } = options;
  let intValue = defaultValue;
  if (value !== null) {
    const int = parseInt(value);
    if (Number.isInteger(int)) {
      intValue = applyRange(int, options);
    }
  }
  if (intValue !== null) {
    return intValue * itemSizeMultiplier + Math.max(intValue - 1, 0) * itemSpaceBetween;
  }
  return null;
};
export const attrValueToPixels = function (value) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_INTEGER_OPTIONS;
  const int = attrValueToInteger(value, options);
  return int === null ? 'unset' : `${int}px`;
};
export const updateIntegerAttribute = function ($element, attrName, attrValue) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_INTEGER_OPTIONS;
  const {
    defaultValue = null,
    itemSizeMultiplier: multiplier = 1
  } = options;
  let intValue = null;
  if (typeof attrValue === 'string') {
    intValue = attrValueToInteger(attrValue, options);
  } else if (typeof attrValue === 'number') {
    intValue = applyRange(attrValue, options) * multiplier;
  } else {
    intValue = defaultValue;
  }
  if (intValue === null) {
    $element.removeAttribute(attrName);
  } else {
    $element.setAttribute(attrName, intValue.toFixed(0));
  }
};
export function getIntegerAttribute($element, attrName, defaultValue) {
  return attrValueToInteger($element.getAttribute(attrName)) ?? defaultValue;
}
export const setClass = (elem, name, isSet) => {
  isSet ? elem.classList.add(name) : elem.classList.remove(name);
};
export const hasClass = (elem, name) => {
  return elem.classList.contains(name);
};
export const getCssVar = (element, variableName) => {
  const result = getComputedStyle(element).getPropertyValue(variableName).trim();
  return result === '' ? null : result;
};
export const getCssVars = (element, variableNames) => {
  const style = getComputedStyle(element);
  return variableNames.map(name => {
    const result = style.getPropertyValue(name).trim();
    return result === '' ? null : result;
  });
};
export const cloneNode = (el, deep) => {
  const root = el.getRootNode();
  if (root !== document && Reflect.has(root, 'createElement')) {
    const cloned = root.createElement(el.tagName.toLowerCase());
    for (const attr of el.getAttributeNames()) {
      cloned.setAttribute(attr, el.getAttribute(attr));
    }
    if (deep) {
      for (let i = 0; i < el.children.length; i++) {
        const clonedChild = cloneNode(el.children[i], deep);
        cloned.appendChild(clonedChild);
      }
    }
    return cloned;
  }
  return el.cloneNode(deep);
};
export const shouldReduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
export const isAttrEqual = (oldVal, newVal) => {
  return oldVal === newVal || newVal === null && oldVal === 'false' || newVal === '' && oldVal === 'true';
};